/** Группа панели переключения компаний: буква и компании на неё, по алфавиту. */
export type CompanyLetterGroup<T> = { letter: string; items: T[] }

export const DIGITS_GROUP = "0–9"
export const OTHER_GROUP = "#"

// Организационно-правовая форма не участвует в алфавите: «ООО «ИТ2ТВ»» стоит на «И».
const LEGAL_FORM = /^(ооо|оао|зао|пао|ао|ип|llc|ltd|inc)(?=[^\p{L}\p{N}])/iu
const LEADING_JUNK = /^[^\p{L}\p{N}]+/u

const collator = new Intl.Collator(["ru", "en"], { sensitivity: "base", numeric: true })

/** Название без кавычек, подчёркиваний и ОПФ в начале — по нему сортируем и выбираем букву. */
export function companySortKey(name: string): string {
  const trimmed = name.replace(LEADING_JUNK, "")
  const withoutForm = trimmed.replace(LEGAL_FORM, "").replace(LEADING_JUNK, "")
  return withoutForm || trimmed
}

export function companyGroupLetter(name: string): string {
  const first = Array.from(companySortKey(name))[0]
  if (!first) return OTHER_GROUP
  if (/\p{N}/u.test(first)) return DIGITS_GROUP
  // «Ё» живёт в группе «Е», как в словарях.
  return first.toLocaleUpperCase("ru").replace("Ё", "Е")
}

export function groupCompaniesByLetter<T>(items: T[], nameOf: (item: T) => string): CompanyLetterGroup<T>[] {
  const sorted = [...items].sort((a, b) => collator.compare(companySortKey(nameOf(a)), companySortKey(nameOf(b))))
  const groups: CompanyLetterGroup<T>[] = []
  for (const item of sorted) {
    const letter = companyGroupLetter(nameOf(item))
    const last = groups[groups.length - 1]
    if (last && last.letter === letter) last.items.push(item)
    else groups.push({ letter, items: [item] })
  }
  return groups
}
